// Mock data for Axaca Solutions Logistiques

export const SITE_CONTENT = {
  fr: {
    nav: {
      what: 'Services',
      why: 'Mission',
      how: 'Approche',
      who: 'Équipe',
      contact: 'Contact',
      quote: 'Soumission',
    },
    hero: {
      eyebrow: 'Depuis 2023',
      title1: 'Faites de votre',
      titleHighlight: 'logistique',
      title2: 'un véritable levier de croissance.',
      subtitle:
        'Axaca Solutions Logistiques aide les entreprises à transformer leur chaîne d’approvisionnement en avantage concurrentiel.',
      cta1: 'Alignez votre stratégie',
      cta2: 'Demander une soumission',
      stats: [
        { value: '2023', label: 'Fondée' },
        { value: '500+', label: 'Expéditions gérées' },
        { value: '40+', label: 'Transporteurs partenaires' },
        { value: '24/7', label: 'Support stratégique' },
      ],
    },
    what: {
      tag: 'SERVICES',
      title: 'Ce que nous faisons',
      description:
        'Axaca Solutions Logistiques est une entreprise spécialisée en courtage de transport et en consultation logistique pour les travailleurs autonomes et les PME. Nous connectons nos clients aux transporteurs les plus fiables et compétitifs, tout en leur offrant un accompagnement stratégique.',
      services: [
        {
          icon: 'Workflow',
          title: 'Chaîne d’approvisionnement',
          desc: 'Amélioration et fiabilisation de bout en bout.',
        },
        {
          icon: 'Handshake',
          title: 'Tarifs négociés',
          desc: 'Négociation de tarifs de transport avantageux et fiables.',
        },
        {
          icon: 'Globe2',
          title: 'Envois nationaux & internationaux',
          desc: 'Gestion complète de vos expéditions au Canada et à l’étranger.',
        },
        {
          icon: 'LineChart',
          title: 'Optimisation des coûts',
          desc: 'Analyse et optimisation de vos coûts logistiques.',
        },
      ],
    },
    why: {
      tag: 'MISSION',
      title: 'Notre raison d’être',
      lead:
        'Nous croyons que toutes les entreprises, peu importe leur taille, méritent une logistique performante et abordable.',
      paragraph:
        'Dans un marché de plus en plus compétitif, une chaîne d’approvisionnement efficace peut faire la différence entre croître ou stagner.',
      bullets: [
        'Favoriser une gestion plus intelligente et durable des expéditions',
        'Démocratiser l’accès à des solutions logistiques efficaces',
        'Aider les PME à réduire leurs coûts de transport',
      ],
    },
    how: {
      tag: 'APPROCHE',
      title: 'Notre approche simple',
      lead:
        'Nous combinons un réseau de partenaires fiables et une expertise terrain pour livrer des résultats concrets.',
      steps: [
        {
          step: '01',
          title: 'Analyse de vos opérations',
          desc: 'Identifier les points d’optimisation logistique possibles.',
        },
        {
          step: '02',
          title: 'Solutions sur mesure',
          desc: 'Proposition de stratégies logistiques adaptées à vos besoins.',
        },
        {
          step: '03',
          title: 'Prise en charge complète',
          desc: 'Sélection de transporteurs et négociation de taux.',
        },
      ],
    },
    who: {
      tag: 'ÉQUIPE',
      title: 'Notre équipe',
      paragraphs: [
        'Forts de plusieurs années d’expérience dans le domaine, nous avons vu de près les défis que rencontrent les entreprises pour gérer efficacement leurs expéditions et optimiser leurs coûts.',
        'Axaca Solutions Logistiques a été fondée par des professionnelles passionnées de logistique, de transport et de solutions d’affaires innovantes.',
      ],
      callout:
        'Nous ne sommes pas un simple courtier : nous sommes des partenaires engagés, des stratèges logistiques, et des alliés de votre croissance.',
    },
    quote: {
      tag: 'SOUMISSION',
      title: 'Demandez une soumission de transport',
      subtitle:
        'Décrivez votre besoin et notre équipe vous revient avec une proposition compétitive sous 24h ouvrables.',
      labels: {
        name: 'Nom complet',
        company: 'Entreprise',
        email: 'Courriel',
        phone: 'Téléphone',
        origin: 'Origine',
        destination: 'Destination',
        type: 'Type d’envoi',
        weight: 'Poids (lbs)',
        details: 'Détails additionnels',
        submit: 'Envoyer la demande',
        success: 'Merci ! Votre demande a été enregistrée. Nous vous contacterons sous peu.',
      },
      types: ['LTL', 'FTL', 'Colis', 'International', 'Spécialisé'],
    },
    footer: {
      tagline: 'Courtage de transport & consultation logistique',
      address: ['230 Boul. Sir-Wilfrid-Laurier', 'Beloeil, QC J3G 4G7'],
      email: 'info@axaca.solutions',
      phone: '+1-579-509-2979',
      ctqInt: 'CTQ INT. # 0-C-31686-I',
      hoursTitle: 'Heures d’affaires',
      hoursLine1: 'Lundi — Vendredi',
      hoursLine2: '8:00 — 17:00 H.E.',
      hoursLine3: 'À l’exception des jours fériés',
      copyright: '© Axaca Solutions Logistiques Inc. 2026',
      privacy: 'Politique de confidentialité',
      terms: 'Termes de services logistiques',
    },
  },
  en: {
    nav: {
      what: 'Services',
      why: 'Mission',
      how: 'Approach',
      who: 'Team',
      contact: 'Contact',
      quote: 'Get a Quote',
    },
    hero: {
      eyebrow: 'Since 2023',
      title1: 'Turn your',
      titleHighlight: 'logistics',
      title2: 'into a real growth engine.',
      subtitle:
        'Axaca Logistics Solutions helps businesses transform their supply chain into a competitive advantage.',
      cta1: 'Align your strategy',
      cta2: 'Request a quote',
      stats: [
        { value: '2023', label: 'Founded' },
        { value: '500+', label: 'Shipments handled' },
        { value: '40+', label: 'Carrier partners' },
        { value: '24/7', label: 'Strategic support' },
      ],
    },
    what: {
      tag: 'SERVICES',
      title: 'What we do',
      description:
        'Axaca Logistics Solutions is a transportation brokerage and logistics consulting firm dedicated to self-employed professionals and small-to-mid-sized businesses. We connect you to the most reliable and competitive carriers while providing strategic support to optimize your logistics operations.',
      services: [
        {
          icon: 'Workflow',
          title: 'Supply chain optimization',
          desc: 'End-to-end improvement and reliability.',
        },
        {
          icon: 'Handshake',
          title: 'Negotiated rates',
          desc: 'Reliable, competitive freight rate negotiation.',
        },
        {
          icon: 'Globe2',
          title: 'Domestic & international',
          desc: 'Complete shipment management in Canada and abroad.',
        },
        {
          icon: 'LineChart',
          title: 'Cost optimization',
          desc: 'Analysis and optimization of your logistics costs.',
        },
      ],
    },
    why: {
      tag: 'MISSION',
      title: 'Our purpose',
      lead:
        'We believe every business — regardless of size — deserves performant and affordable logistics.',
      paragraph:
        'In an increasingly competitive market, an efficient supply chain can make the difference between growth and stagnation.',
      bullets: [
        'Foster smarter, more sustainable shipping management',
        'Democratize access to effective logistics solutions',
        'Help SMBs reduce their transportation costs',
      ],
    },
    how: {
      tag: 'APPROACH',
      title: 'Our simple approach',
      lead:
        'We combine a reliable partner network with field expertise to deliver concrete results.',
      steps: [
        {
          step: '01',
          title: 'Operations analysis',
          desc: 'Identifying possible logistics optimization points.',
        },
        {
          step: '02',
          title: 'Tailored solutions',
          desc: 'Crafting logistics strategies that fit your needs.',
        },
        {
          step: '03',
          title: 'Full shipment handling',
          desc: 'Carrier selection and rate negotiation.',
        },
      ],
    },
    who: {
      tag: 'TEAM',
      title: 'Our team',
      paragraphs: [
        'With years of hands-on experience, we’ve seen first-hand the challenges businesses face managing shipments and optimizing costs.',
        'Axaca Logistics Solutions was founded by professionals passionate about logistics, transportation, and innovative business solutions.',
      ],
      callout:
        'We are not just brokers: we are committed partners, logistics strategists, and allies of your growth.',
    },
    quote: {
      tag: 'QUOTE',
      title: 'Request a transportation quote',
      subtitle:
        'Describe your need and our team will come back with a competitive proposal within 24 business hours.',
      labels: {
        name: 'Full name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        origin: 'Origin',
        destination: 'Destination',
        type: 'Shipment type',
        weight: 'Weight (lbs)',
        details: 'Additional details',
        submit: 'Send request',
        success: 'Thank you! Your request was saved. We will be in touch shortly.',
      },
      types: ['LTL', 'FTL', 'Parcel', 'International', 'Specialized'],
    },
    footer: {
      tagline: 'Freight brokerage & logistics consulting',
      address: ['230 Boul. Sir-Wilfrid-Laurier', 'Beloeil, QC J3G 4G7'],
      email: 'info@axaca.solutions',
      phone: '+1-579-509-2979',
      ctqInt: 'CTQ INT. # 0-C-31686-I',
      hoursTitle: 'Business hours',
      hoursLine1: 'Monday — Friday',
      hoursLine2: '8:00 AM — 5:00 PM E.T.',
      hoursLine3: 'Except on holidays',
      copyright: '© Axaca Logistics Solutions Inc. 2026',
      privacy: 'Privacy Policy',
      terms: 'Logistics Services Terms',
    },
  },
};

export const TESTIMONIALS = {
  fr: [
    {
      quote:
        'Axaca a simplifié notre logistique du jour au lendemain. Des tarifs imbattables et un service humain.',
      author: 'Marie L.',
      role: 'PME — Manufacturier, Montréal',
    },
    {
      quote:
        'Un vrai partenaire stratégique. Ils ont réduit nos coûts d’expédition de 18%.',
      author: 'David B.',
      role: 'Directeur des opérations',
    },
    {
      quote:
        'Réactifs, transparents, et toujours là quand on en a besoin. On recommande sans réserve.',
      author: 'Sophie R.',
      role: 'E-commerce — Québec',
    },
  ],
  en: [
    {
      quote:
        'Axaca simplified our logistics overnight. Unbeatable rates and a human service.',
      author: 'Marie L.',
      role: 'SMB — Manufacturer, Montreal',
    },
    {
      quote:
        'A real strategic partner. They cut our shipping costs by 18%.',
      author: 'David B.',
      role: 'Operations Director',
    },
    {
      quote:
        'Responsive, transparent, and always there when needed. Highly recommended.',
      author: 'Sophie R.',
      role: 'E-commerce — Quebec',
    },
  ],
};

export const PARTNERS = [
  'Canada Cartage',
  'TFI International',
  'Day & Ross',
  'Manitoulin',
  'Polaris',
  'GroupeRobert',
  'XPO',
  'Old Dominion',
];
